export const logout = payload => ({ type: 'LOGOUT', payload })
export const logoutSuccess = () => ({ type: 'LOGOUT__SUCCESS' })
